import {
    checkForAlpine,
    componentData,
} from './utils'

import includes from 'lodash/includes';
import xor from "lodash/xor";
import isArray from "lodash/isArray";
import intersection from "lodash/intersection";
import union from 'lodash/union';
import pullAll from 'lodash/pullAll';
import set from 'lodash/set';
import get from 'lodash/get';

const AlpineToggleMagicMethod = {
    start() {
        checkForAlpine()

        Alpine.addMagicProperty('array', () => {
            return {
                add(data, values) {
                    if (!Array.isArray(data)) return;
                    values = Array.isArray(values) ? values : [values];
                    values.forEach((value) => {
                        if(data.indexOf(value) === -1) {
                           data.push(value);
                        }
                    });
                },
                remove(data, values) {
                    if (!Array.isArray(data)) return;
                    values = Array.isArray(values) ? values : [values];
                    pullAll(data, values);
                },
            };
        })

        Alpine.addMagicProperty('includes', ($el) => {
            return (key, ...value) => {
                let data = componentData($el);

                if (typeof data[key] === "undefined") return false;

                // If both arrays - confirm all values in array
                if (value.length > 1 && isArray(data[key])) {
                    return intersection(data[key], value).length === value.length;
                }

                // Confirm single value in array or string
                return includes(data[key], value[0]);
            };
        })

        Alpine.addMagicProperty('toggle', ($el) => {
            return (key, value, toggleValue) => {
                let data = componentData($el);

                // If key not found
                if (typeof data[key] === "undefined") return;

                // If toggling between two values
                if (typeof toggleValue !== 'undefined') {
                    return $el.__x.$data[key] = data[key] === value ? toggleValue : value;
                }

                // If toggle boolean
                if (typeof data[key] === 'boolean') {
                    return $el.__x.$data[key] = !data[key];
                }

                // if toggle presence in an array
                if (isArray(data[key])) {
                    return $el.__x.$data[key] = xor(data[key], [value]);
                }
            }
        })
    },
}

const alpine = window.deferLoadingAlpine || ((alpine) => alpine())

window.deferLoadingAlpine = function (callback) {
    AlpineToggleMagicMethod.start()

    alpine(callback)
}

export default AlpineToggleMagicMethod;
